import { useLayoutEffect, useRef, useState } from "react";

/** Renders children at their natural size (up to maxWidth) and scales them down to fit the parent's box. */
export function FitToScreen({ children, maxWidth = 896, className = "", testid }) {
  const wrap = useRef(null);
  const inner = useRef(null);
  const [box, setBox] = useState({ scale: 1, w: maxWidth, h: 0 });

  useLayoutEffect(() => {
    const parent = wrap.current?.parentElement;
    const el = inner.current;
    if (!parent || !el) return;
    const calc = () => {
      const cs = getComputedStyle(parent);
      const availW = parent.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      const availH = parent.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
      const w = Math.min(maxWidth, availW);
      el.style.width = `${w}px`;
      const h = el.offsetHeight;
      const scale = h > 0 && availH > 0 ? Math.min(1, availH / h) : 1;
      setBox({ scale, w, h });
    };
    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(parent);
    ro.observe(el);
    window.addEventListener("resize", calc);
    return () => { ro.disconnect(); window.removeEventListener("resize", calc); };
  }, [maxWidth]);

  return (
    <div ref={wrap} style={{ width: box.w * box.scale, height: box.h ? box.h * box.scale : undefined }} className="relative shrink-0 kiosk-rise" data-testid={testid} data-scale={box.scale.toFixed(3)}>
      <div ref={inner} className={className} style={{ width: box.w, transform: `scale(${box.scale})`, transformOrigin: "top left", position: box.h ? "absolute" : "relative", top: 0, left: 0 }}>
        {children}
      </div>
    </div>
  );
}
